<template>
    <div id="accordion-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Background + ' ' + moduleData.Spacing" :id="moduleData.AnchorID">
            <div class="container">
                <p class="heading" v-if="moduleData.Title && moduleData.ShowTitle">{{moduleData.Title}}</p>
                <hr v-if="moduleData.Title && moduleData.ShowTitle">
                <div class="accordion" v-for="(block, index) in moduleData.TextBlocks" :key="index">
                    <p class="accordion-toggle" v-b-toggle="'element-' + moduleData.ID + '-module-' + index">
                        {{block.Title}}
                        <span class="when-opened"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                        <span class="when-closed"><i class="fa fa-chevron-up" aria-hidden="true"></i></span>
                    </p>
                    <b-collapse class="accordion-body" :id="'element-' + moduleData.ID + '-module-' + index">
                        <div class="wysiwyg" v-html="block.ParsedContent"></div>
                    </b-collapse>
                    <hr>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "AccordionElement",
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        },
        methods: {
            ...mapActions(['fetchModuleData']),
        }
    }
</script>
